import { ICatalogProvider } from '../../../interfaces/service/CatalogServiceManagerInterface';

interface ICatalogListProps {
  serviceCatalog: ICatalogProvider;
}

export const CatalogsList = (props: ICatalogListProps) => {
  const { serviceCatalog } = props;

  const renderMenu = () => {
    return (
      <div className="h-full w-full flex flex-col ">
        {serviceCatalog.catalogList.map((item: any, index: number) => {
          return (
            <div
              title={item.name}
              className={`flex flex-col mb-1 p-1 justify-center text-center cursor-pointer shadow-lg hover:bg-shadow_green text-grey hover:!text-official_green ${
                item.name === serviceCatalog.selectCatalog
                  ? 'text-official_green'
                  : ''
              }`}
              key={index}
              onClick={() => serviceCatalog.catalogSelect(item)}>
              <div className="flex w-full h-8  justify-center content-center items-center cursor-pointer ">
                {item.icon}
              </div>
              <div className="flex justify-center text-sm break-words">
                {item.name}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="flex h-full w-full  overflow-y-auto absolute ">
      {renderMenu()}
    </div>
  );
};
